import { orderBy } from 'lodash'
import { useRouter } from 'next/router'
import { reportCategory } from 'src/api'
import { getNumberQueryParam } from 'src/utils/RouterUtil'
import useSWR from 'swr/immutable'
import { useNewApiClient } from '../useNewApiClient'

const reportCategorySorter = (
  report_caregories: reportCategory[]
): reportCategory[] => {
  const sorted_report_categories = report_caregories.map((v) => {
    return {
      category_type: v.category_type,
      account_items: orderBy(
        v.account_items,
        ['order_no', 'id'],
        ['desc', 'asc']
      )
    }
  })

  return sorted_report_categories
}

export const usePartnerTaxAccountantCategories = () => {
  const { apiClient } = useNewApiClient()
  const router = useRouter()
  const id = getNumberQueryParam(router.query, 'id')
  const year = getNumberQueryParam(router.query, 'year')

  const { data: categories } = useSWR(
    year && id
      ? `/partner_tax_accountant/categories?year=${year}&id=${id}`
      : null,
    async () => {
      if (year === undefined || id === undefined) return
      const res =
        await apiClient.taxAccountant.getPartnerTaxAccountantReportCategories(
          year,
          id
        )
      return res
    }
  )

  const sorted_report_category = reportCategorySorter(
    categories?.report_categories || []
  )

  const report_categories_flatten = sorted_report_category?.flatMap(
    (v) => v.account_items
  )

  return {
    sorted_report_category,
    report_categories_flatten
  }
}
